import React from 'react';
import { SeekActor } from './Seek/seekTypes';
import { FMDActor } from './FMDQueryComponent/fmdMachine';

// Define the shape of the context state
interface ApplicationContextState {
  fetch: (url: string, init?: RequestInit) => Promise<Response>;
  xstate: {
    fmdService: FMDActor | null;
    seekService: SeekActor | null;
  };
}

// Create the context with the initial state shape
const ApplicationContext = React.createContext<ApplicationContextState>({
  fetch: (url: string, init?: RequestInit): Promise<Response> => {
    throw new Error('Fetch method not initialized.');
  },
  xstate: {
    fmdService: null,
    seekService: null,
  },
});

export default ApplicationContext;
